import { Record } from 'immutable';

const TradeInVehicleRecord = Record({
    vehicle: null,
    lien: {
        owner: '',
        amount: 0,
    },
    estimation: null,
    amount: 0,
    evaluationQuestion: [
        {
            question: 'Q1',
            answer: {
                value: undefined,
            },
        },
        {
            question: 'Q2',
            answer: {
                value: undefined,
                details: '',
            },
        },
        {
            question: 'Q3',
            answer: {
                value: undefined,
            },
        },
        {
            question: 'Q4 ',
            answer: [
                {
                    value: undefined,
                    details: {
                        year: 0,
                        month: 0,
                        receipt: false,
                    },
                },
                {
                    value: undefined,
                    details: {
                        year: 0,
                        month: 0,
                        receipt: false,
                    },
                },
            ],
        },
        {
            question: 'Q5',
            answer: {
                value: undefined,
                details: '',
            },
        },
        {
            question: 'Q6',
            answer: {
                value: undefined,
            },
        },
        {
            question: 'Q7',
            answer: {
                details: '',
            },
        },
    ],
});

class TradeInVehicleModel extends TradeInVehicleRecord {}

export default TradeInVehicleModel;
